// extracted by mini-css-extract-plugin
module.exports = {"cardSupplyDays":"styles_cardSupplyDays__9sPmJ","boldDateText":"styles_boldDateText__6AJWa","expressSupplyDays":"styles_expressSupplyDays__xISxz"};